import React, { useEffect, useState, useLocation } from 'react';
import Newservice from '../../views/PartnerView/NewService';

const NewServiceComponent = () => {
  
    return <Newservice />;
   
};

export default NewServiceComponent;
